import { type LeaveRequestItem } from '@gb-ticket/shared-types';

import { formatLeaveDays } from '@/products/leave/features/preview-vacation-days';

export function nextApprovedAbsence(
  items: readonly LeaveRequestItem[],
  today: string,
): LeaveRequestItem | null {
  const upcoming = items
    .filter((item) => item.status === 'approved' && item.endsOn >= today)
    .sort((left, right) => left.startsOn.localeCompare(right.startsOn));
  return upcoming[0] ?? null;
}

export function formatCarryOverHint(carryOverDays: number, expiresOn: string): string {
  const day = expiresOn.slice(8, 10);
  const month = expiresOn.slice(5, 7);
  return `davon ${formatLeaveDays(carryOverDays)} bis ${day}.${month}.`;
}

export function formatOvertimeHours(hours: number): string {
  return `${new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(hours)} h`;
}
